import { render, staticRenderFns } from "./BulkUploadSpec.vue?vue&type=template&id=949d8668&scoped=true&"
import script from "./BulkUploadSpec.vue?vue&type=script&setup=true&lang=js&"
export * from "./BulkUploadSpec.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BulkUploadSpec.vue?vue&type=style&index=0&id=949d8668&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949d8668",
  null
  
)

export default component.exports